import React from "react";
import { Form } from "react-bootstrap";

function Checkbox({ id, ...restProps }) {
  return (
    <Form.Check id={`checkbox${id}`} custom type={"checkbox"} {...restProps} />
  );
}

export default Checkbox;
